import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getSeventhAnalyses = asyncThunkWrapper({ 
  model: 'seventhAnalyses', 
  action: 'getSeventhAnalyses', 
  func: async ({ offset = 0 }) => {
    const attributes = ['id', 'input', 'status', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/seventh_flow/seventh_analyses', { params });

    return response.data;
  } 
});
export const getSeventhAnalysis = asyncThunkWrapper({ 
  model: 'seventhAnalyses', 
  action: 'getSeventhAnalysis', 
  func: async ({ id, cable = false }) => {
    const attributes = ['id', 'input', 'result', 'voice', 'status', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/seventh_analyses/${id}`, { params });

    return { data: response.data, cable };
  } 
});
export const clearLocalSeventhAnalyses = createAction('seventhAnalyses/clearLocalSeventhAnalyses');
export const clearLocalActiveSeventhAnalysis = createAction('seventhAnalyses/clearLocalActiveSeventhAnalysis');